export const typeformFiles = {
  activeUploadFileList() {
    const method = this.selectedValidationMethod()
    const flow = this.uploadFlowTargets.find((element) => element.dataset.uploadFlow === method)
    return flow?.querySelector("[data-typeform-target~='fileList']") || null
  },

  syncUploadStepVisibility() {
    const method = this.selectedValidationMethod()
    this.uploadFlowTargets.forEach((element) => {
      element.classList.toggle("hidden", element.dataset.uploadFlow !== method)
    })
    this.uploadFlowTargets.forEach((flow) => {
      flow.querySelector("[data-upload-validation-gate]")?.replaceChildren()
    })
    if (method === "screen_share_capture") this.syncScreenShareExpected()
  },

  updateFileList(event) {
    const fileList = this.activeUploadFileList()
    if (!fileList) return

    this.revokeFilePreviewUrls()
    const files = event.currentTarget.files
    fileList.innerHTML = ""

    const hasFiles = files.length > 0
    this.syncUploadDropzoneState(hasFiles, files.length)

    Array.from(files).forEach((file) => {
      const item = document.createElement("div")
      item.className =
        "flex items-center gap-4 rounded-xl border border-emerald-200/90 bg-white p-3 shadow-sm sm:p-4"

      const size = (file.size / 1024 / 1024).toFixed(2)
      const readyLabel = this.t("upload.ready_label", "Ready to upload")
      let previewHtml

      if (file.type.startsWith("image/")) {
        const url = URL.createObjectURL(file)
        this.filePreviewUrls.push(url)
        previewHtml = `<img src="${url}" alt="" class="h-16 w-16 rounded-lg border border-slate-200/90 object-cover sm:h-20 sm:w-20" />`
      } else {
        previewHtml = `<span class="flex h-16 w-16 items-center justify-center rounded-lg border border-slate-200/90 bg-slate-50 text-2xl sm:h-20 sm:w-20" aria-hidden="true">📄</span>`
      }

      item.innerHTML = `
        <div class="relative shrink-0">
          ${previewHtml}
          <span class="absolute -bottom-1.5 -right-1.5 flex h-6 w-6 items-center justify-center rounded-full bg-emerald-500 text-white shadow-sm" aria-hidden="true">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="h-3.5 w-3.5">
              <path fill-rule="evenodd" d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z" clip-rule="evenodd" />
            </svg>
          </span>
        </div>
        <div class="min-w-0 flex-1">
          <p class="truncate text-sm font-semibold text-slate-950 sm:text-base">${file.name}</p>
          <p class="mt-0.5 text-xs font-medium text-emerald-700">${readyLabel}</p>
          <p class="text-xs text-slate-500">${size} MB</p>
        </div>
      `
      fileList.appendChild(item)
    })

    this.activeUploadValidationGate()?.replaceChildren()
  },

  openFilePicker() {
    this.supportingDocumentsInputTarget?.click()
  },

  syncUploadDropzoneState(hasFiles, fileCount = 0) {
    if (this.selectedValidationMethod() !== "document_upload") return

    if (this.hasUploadDropzoneLabelTarget) {
      this.uploadDropzoneLabelTarget.classList.toggle("hidden", hasFiles)
    }
    if (this.hasUploadSelectedPanelTarget) {
      this.uploadSelectedPanelTarget.classList.toggle("hidden", !hasFiles)
    }
    if (hasFiles && this.hasUploadSelectedHeadingTarget) {
      const heading =
        fileCount === 1
          ? this.t("upload.file_ready_one", "1 file ready")
          : this.t("upload.file_ready_other", "%{count} files ready").replace("%{count}", String(fileCount))
      this.uploadSelectedHeadingTarget.textContent = heading
    }
  },

  revokeFilePreviewUrls() {
    if (!this.filePreviewUrls) return
    for (const url of this.filePreviewUrls) URL.revokeObjectURL(url)
    this.filePreviewUrls = []
  }
}
